import * as R from 'ramda';
import './modal-stack.js';
import { initEnvValue } from '../../../packages/src/envs/index.js';
import * as utilsModules from './utils-module.js';
import { initItemCounter } from '../kioskStore/js/itemCounter.js';
import * as itemSelectCounter from '../kioskStore/js/itemSelectCounter.js';
import { getWebappDomain } from '../../../packages/src/utils/domain.js';

// Envs
initEnvValue('NODE_ENV', process.env.NODE_ENV);
initEnvValue('PHOTO_ALBUM_URL', process.env.PHOTO_ALBUM_URL);
initEnvValue('EVENTS_SITE_URL', process.env.EVENTS_SITE_URL);
initEnvValue('KIOSK_URL', process.env.KIOSK_URL);
initEnvValue('PHOTO_BOOTH', process.env.PHOTO_BOOTH);
initEnvValue('PHOTO_STREAM_SITE_URL', process.env.PHOTO_STREAM_SITE_URL);
initEnvValue('BACKEND_API', process.env.BACKEND_API);
initEnvValue('POOL_DATA_USER_ID', process.env.POOL_DATA_USER_ID);
initEnvValue('POOL_DATA_CLIENT_ID', process.env.POOL_DATA_CLIENT_ID);
initEnvValue('IMG_PATH', process.env.IMG_PATH);
initEnvValue('ASSET_PATH', process.env.ASSET_PATH);
initEnvValue('AWS_REGION', process.env.AWS_REGION);
initEnvValue('PAYPAL_ENV', process.env.PAYPAL_ENV);
initEnvValue('PAYPAL_CLIENT_ID', process.env.PAYPAL_CLIENT_ID);
initEnvValue('WEBAPP_URL', getWebappDomain());
initEnvValue('ROAMERAPP_URL', process.env.ROAMERAPP_URL);
initEnvValue('DEBUG_MODE', process.env.DEBUG_MODE, false);
initEnvValue('SENTRY_ENV', process.env.SENTRY_ENV, process.env.BITBUCKET_COMMIT !== undefined);
initEnvValue('TRACKER_PATH', process.env.TRACKER_PATH);
Object.keys(utilsModules).forEach((name) => {
  window[name] = utilsModules[name];
});

const methodsFromRamda = ['groupBy', 'zip'];
methodsFromRamda.forEach((name) => {
  window[name] = R[name];
});

window.initItemCounter = initItemCounter;
window.itemSelectCounter = itemSelectCounter;

function selectPhoto(index, selectedPhotos, photos) {
  if (selectedPhotos.length > index) return selectedPhotos[index];
  return photos[index % photos.length];
}
window.selectPhoto = selectPhoto;

// Подключаем логику стэкинга модалей (если jQuery доступен в клиенте)
